import { Component, OnInit, inject } from '@angular/core';
import { CommonService } from '../../common.service';

@Component({
  selector: 'app-why',
  templateUrl: './why.html',
  styleUrl: './why.scss',
})
export class Why implements OnInit {
  private readonly commonService = inject(CommonService);

  ngOnInit(): void {
    this.commonService.showTitle('/assets/titles/why.jpg');
  }
}
